module.exports = __webpack_public_path__ + "static/media/locationDashboard.f80d6819.png";